import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const GalleryItemWrapper = styled.li`
  position: relative;
  background-size: 100% auto;
  background-position: center;
  flex: 0 0 100%;
  padding-top: 90vw;
  display: block;
  transition: all .3s;
  cursor: pointer;
  &:hover {
    background-size: 110% auto;
  }
  flex-wrap: wrap;
  @media (min-width: ${breakpoints.tablet}) {
    flex-wrap: nowrap;
    flex: 0 0 50%;
    padding-top: 47vw;
  }
  @media (min-width: ${breakpoints.desktop}) {
    flex-wrap: nowrap;
    flex: 0 0 33.33%;
    padding-top: 30vw;
  }
`;

export default GalleryItemWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/GalleryItemWrapper.js